import AnnouncementIcon from '@material-ui/icons/Announcement';

export default {
  config: {
    icon: AnnouncementIcon,
    options: {
      label: 'Annonces',
    },
  },
  translations: {
    fr: {
      name: 'Annonce |||| Annonces',
    },
    fenr: {
      name: 'Announcement |||| Announcements',
    },
  },
};
